// Generated by purs version 0.15.15
import * as Affjax from "../Affjax/index.js";
import * as Affjax_RequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_Web from "../Affjax.Web/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_HTTP_Method from "../Data.HTTP.Method/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_MediaType_Common from "../Data.MediaType.Common/index.js";
import * as Data_OneOf from "../Data.OneOf/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Eq.eqString);
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "message";
    }
});
var unsafeDecode = /* #__PURE__ */ Unscramble.unsafeDecode(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "details";
    }
})(Unscramble.decodeForeign)(/* #__PURE__ */ Unscramble.decodeRecordCons({
    reflectSymbol: function () {
        return "error";
    }
})(Unscramble.decodeString1)(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil)))));
var decodeWithTagU = /* #__PURE__ */ Data_OneOf.decodeWithTagU();
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var ix = /* #__PURE__ */ Foreign_Index.ix(/* #__PURE__ */ Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(/* #__PURE__ */ Foreign_Index.indexString(Data_Identity.monadIdentity));
var readString = /* #__PURE__ */ Foreign.readString(Data_Identity.monadIdentity);
var readNullOrUndefined = /* #__PURE__ */ Foreign.readNullOrUndefined(Data_Identity.monadIdentity);
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableMaybe)(applicativeExceptT);
var readProp = /* #__PURE__ */ Foreign_Index.readProp(Data_Identity.monadIdentity);
var decodeWithTag = /* #__PURE__ */ Data_OneOf.decodeWithTag();
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(/* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(Effect_Aff.monadAff));
var expand$prime = /* #__PURE__ */ Data_OneOf["expand$prime"]();
var inj = /* #__PURE__ */ Data_OneOf.inj();
var inj1 = /* #__PURE__ */ inj({
    reflectSymbol: function () {
        return "GenericError";
    }
});
var inj2 = /* #__PURE__ */ inj({
    reflectSymbol: function () {
        return "UnknownError";
    }
});
var inj3 = /* #__PURE__ */ inj({
    reflectSymbol: function () {
        return "NetworkError";
    }
});
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var withExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.withExceptT(Effect_Aff.functorAff);
var inj4 = /* #__PURE__ */ inj({
    reflectSymbol: function () {
        return "Unauthorized";
    }
});
var GenericError = /* #__PURE__ */ (function () {
    function GenericError(value0) {
        this.value0 = value0;
    };
    GenericError.create = function (value0) {
        return new GenericError(value0);
    };
    return GenericError;
})();
var ErrorResponse = /* #__PURE__ */ (function () {
    function ErrorResponse(value0) {
        this.value0 = value0;
    };
    ErrorResponse.create = function (value0) {
        return new ErrorResponse(value0);
    };
    return ErrorResponse;
})();
var showErrorResponse = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        show: function (v) {
            return show(v.value0.details);
        }
    };
};
var genericGenericError_ = {
    to: function (x) {
        return new GenericError(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var genericErrorResponse_ = {
    to: function (x) {
        return new ErrorResponse(x);
    },
    from: function (x) {
        return x.value0;
    }
};
var eqErrorResponse = function (dictShow) {
    return {
        eq: Data_Function.on(eq)(Data_Show.show(showErrorResponse(dictShow)))
    };
};
var decodeGenericError = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGenericError_)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ decodeRecordCons(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var decodeJSON = /* #__PURE__ */ Unscramble.decodeJSON(decodeGenericError);
var decodeErrorResponse1 = function () {
    return function (dictDecodeWithTagU) {
        var decodeWithTagU1 = decodeWithTagU(dictDecodeWithTagU);
        return {
            unsafeDecode: function (f) {
                var raw = unsafeDecode(f);
                var detailsE = decodeWithTagU1(raw.error)(raw.details);
                if (detailsE instanceof Data_Either.Right) {
                    return new ErrorResponse({
                        message: raw.message,
                        details: detailsE.value0
                    });
                };
                if (detailsE instanceof Data_Either.Left) {
                    return Unscramble.decodingError("Invalid ErrorResponse: " + detailsE.value0);
                };
                throw new Error("Failed pattern match at Network.RPC (line 125, column 7 - line 129, column 63): " + [ detailsE.constructor.name ]);
            }
        };
    };
};
var decodeErrorResponse2 = function () {
    return function (dictDecodeWithTag) {
        var decodeWithTag1 = decodeWithTag(dictDecodeWithTag);
        return {
            decode: function (x) {
                return bind(bind(ix(x)("error"))(readString))(function (v) {
                    return bind(bind(bind(ix(x)("message"))(readNullOrUndefined))(traverse(readString)))(function (message) {
                        return bind(readProp("details")(x))(function (v1) {
                            return bind(decodeWithTag1(v)(v1))(function (details) {
                                return pure(new ErrorResponse({
                                    message: message,
                                    details: details
                                }));
                            });
                        });
                    });
                });
            }
        };
    };
};
var decodeErrorResponse = function (dictDecode) {
    var decodeJSON1 = Unscramble.decodeJSON(dictDecode);
    return function (json) {
        var v = decodeJSON1(json);
        if (v instanceof Data_Maybe.Just) {
            return throwError(expand$prime(Type_Proxy["Proxy"].value)(v.value0.value0.details));
        };
        if (v instanceof Data_Maybe.Nothing) {
            return throwError((function () {
                var v1 = decodeJSON(json);
                if (v1 instanceof Data_Maybe.Just) {
                    return inj1(Type_Proxy["Proxy"].value)(v1.value0.value0.message);
                };
                if (v1 instanceof Data_Maybe.Nothing) {
                    return inj2(Type_Proxy["Proxy"].value)(json);
                };
                throw new Error("Failed pattern match at Network.RPC (line 105, column 7 - line 107, column 66): " + [ v1.constructor.name ]);
            })());
        };
        throw new Error("Failed pattern match at Network.RPC (line 102, column 3 - line 107, column 66): " + [ v.constructor.name ]);
    };
};
var runAffjax = function (dictEncode) {
    var encodeJSON = Foreign_Generic.encodeJSON(dictEncode);
    return function (dictDecode) {
        var decodeJSONE = Network_JsonRPC.decodeJSONE(dictDecode);
        return function (dictDecode1) {
            var decodeErrorResponse3 = decodeErrorResponse(dictDecode1);
            return function (dictRPCMethodName) {
                var rpcMethodName = Network_JsonRPC.rpcMethodName(dictRPCMethodName);
                return function (api) {
                    return function (authHeaders) {
                        return function (request) {
                            var toOneOf = (function () {
                                var $118 = inj3(Type_Proxy["Proxy"].value);
                                return function ($119) {
                                    return $118(Affjax.printError($119));
                                };
                            })();
                            var request$prime = {
                                username: Affjax.defaultRequest.username,
                                password: Affjax.defaultRequest.password,
                                withCredentials: Affjax.defaultRequest.withCredentials,
                                timeout: Affjax.defaultRequest.timeout,
                                url: api + ("/" + rpcMethodName(Type_Proxy["Proxy"].value)),
                                headers: append1(authHeaders)([ new Affjax_RequestHeader.ContentType(Data_MediaType_Common.applicationJSON) ]),
                                method: new Data_Either.Left(Data_HTTP_Method.POST.value),
                                content: new Data_Maybe.Just(Affjax_RequestBody.string(encodeJSON(request))),
                                responseFormat: Affjax_ResponseFormat.string
                            };
                            return bind1(withExceptT(toOneOf)(Affjax_Web.request(request$prime)))(function (response) {
                                if (response.status === 200) {
                                    return decodeJSONE(response.body);
                                };
                                if (response.status === 401) {
                                    return throwError(inj4(Type_Proxy["Proxy"].value)("unauthorized"));
                                };
                                return decodeErrorResponse3(response.body);
                            });
                        };
                    };
                };
            };
        };
    };
};
export {
    runAffjax,
    ErrorResponse,
    GenericError,
    decodeErrorResponse,
    genericErrorResponse_,
    eqErrorResponse,
    genericGenericError_,
    decodeGenericError,
    showErrorResponse,
    decodeErrorResponse2,
    decodeErrorResponse1
};
